<template>
  <wrld-container
    :breadcrumbs="this.breadcrumbs"
    :pageIsLoading="pageIsLoading"
  >
    <div v-if="isUpdate" class="transport-request-form-header">
      <v-row justify="space-between">
        <div>
          <span class="activity-label ml-3">{{$t('general.created_at')}}: </span>
          <b>{{ order.createdAt | unixTStoDateTime($i18n.locale) }}</b>
          {{ order.createdBy !== '' ? ` ${$t('general.by')} ${order.createdBy}` : '' }} <br>
          <span class="activity-label ml-3">{{$t('general.last_update')}}: </span>
          <b>{{ order.lastUpdateAt | unixTStoDateTime($i18n.locale) }}</b>
          {{ order.lastUpdateBy !== '' ? ` ${$t('general.by')} ${order.lastUpdateBy}` : '' }}
        </div>
        <div>
          <TransportRequestsExport v-if="!isEditable" :order="order"/>
          <v-btn class="mr-4 mt-1" v-if="!isEditable" @click="isEditable = true">{{$t('buttons.edit')}}</v-btn>
          <v-btn class="mt-1" v-else @click="callUpdateOrder()">{{$t('buttons.save')}}</v-btn>
          <v-btn class="mr-4 ml-3 mt-1" v-if="isEditable" @click="isEditable = false">{{$t('buttons.cancel')}}</v-btn>
        </div>
      </v-row>
    </div>
    <v-form
      ref="orderForm"
      v-model="valid"
      lazy-validation
    >
      <wrld-box :headerTitle="$tc('transport_request.transport_request', 1)" hideableContent>
        <template v-slot:boxContent>
          <v-row>
            <v-col cols="12">
              <v-alert
                type="error"
                outlined
                :value="notValidCompanies"
              >
                <!-- TODO: fill name of the company -->
                {{ $t('orders.one_has_to_be_your_company', {company: signedInCompany.name})}}
              </v-alert>
            </v-col>
            <v-col class="pl-5 pb-3 pt-3" cols="12" md="3" :class="['tr-priority', { 'disabled':!isEditable }]">
              <v-row>
                <v-col>
                  <label>{{$t('orders.priority')}}</label>
                  <v-radio-group row v-model="order.mode" hide-details class="mt-0" :disabled="!isEditable">
                    <v-radio color="kazan" :label="$t('orders.standard')" value="standard"></v-radio>
                    <v-radio color="kazan" :label="$t('orders.express')" value="express"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pt-3" cols="12" md="3">
              <label for="oredId">{{$t('orders.status')}}</label>
              <v-select
                clearable
                v-model="order.transportRequestStatus"
                :items="orderStatuses"
                single-line
                solo
                :placeholder="$t('orders.select')"
                :disabled="!isEditable"
              ></v-select>
            </v-col>
            <v-col class="pa-3" md="6">
              <div v-if="isUpdate">
                <label for="transportRequestRefNum">{{$t('transport_request.transport_request_ref_num')}}</label>
                <h2>{{order.objectID}}</h2>
                <!-- <v-text-field
                  :disabled="!isEditable"
                  v-model="order.transportRequestRefNum"
                  single-line
                  solo
                ></v-text-field> -->
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <OrderFormAddress
                class="address-origin"
                v-model="order.originAddress"
                direction="origin"
                :isUpdate="isUpdate"
                :isEditable="isEditable"
                :site="order.site"
              />
            </v-col>
            <v-col cols="12" md="6">
              <OrderFormAddress
                class="address-destination"
                v-model="order.destinationAddress"
                direction="destination"
                :isUpdate="isUpdate"
                :isEditable="isEditable"
                :site="order.site"
              />
            </v-col>
          </v-row>
        </template>
      </wrld-box>

      <wrld-box :headerTitle="$t('orders.transport_details')" hideableContent>
        <template v-slot:boxContent>
          <OrderFormDetails v-model="order.orderDetails" :isEditable="isEditable"/>
        </template>
      </wrld-box>

      <wrld-box :headerTitle="`${$t('orders.order_items')} (${itemsCount})`" hideableContent>
        <template v-slot:boxContent>
          <OrderFormCargo v-model="order.cargos" :isEditable="isEditable"/>
        </template>
      </wrld-box>

      <v-alert
        type="error"
        outlined
        :value="order.cargos.length === 0"
      >
        {{$t('orders.minimum_packages')}}
      </v-alert>

      <v-btn @click="goBack()">{{$t('buttons.cancel')}}</v-btn>
      <v-btn v-if="isEditable" @click="callUpdateOrder()">{{$t('buttons.save')}}</v-btn>
      <span v-if="!valid" class="red--text">{{$t('general.not_all_required_fields')}}</span>
    </v-form>
  </wrld-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import router from '@/router'
import moment from 'moment-timezone'
import OrderFormAddress from '@/components/transportRequests/OrderFormAddress.vue'
import OrderFormDetails from '@/components/transportRequests/OrderFormDetails.vue'
import OrderFormCargo from '@/components/transportRequests/OrderFormCargo.vue'
import TransportRequestsExport from '@/components/transportRequests/TransportRequestsExport.vue'
// import axios from '@/plugins/axios-instance.js'
// import { uuid } from 'vue-uuid'
import { transportRequestService } from '@/_services'
// import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
window.html2canvas = html2canvas

export default {
  name: 'TransportRequest',
  components: {
    OrderFormAddress,
    OrderFormDetails,
    OrderFormCargo,
    TransportRequestsExport
  },
  data () {
    return {
      valid: true,
      order: {
        mode: 'standard',
        site: 'selling',
        transportRequestStatus: '',
        originAddress: {
          company: '',
          contact_person: '',
          location: '',
          reference_number: '',
          open_from: null,
          open_to: null,
          fixedDate: false,
          dates_from: null,
          dates_to: null,
          orderStatus: '',
          additionalInfoLocation: ''
        },
        destinationAddress: {
          company: '',
          contact_person: '',
          location: '',
          reference_number: '',
          open_from: null,
          open_to: null,
          fixedDate: false,
          dates_from: null,
          dates_to: null,
          additionalInfoLocation: ''
        },
        orderDetails: {
          specialRequirements: [],
          loadingType: 0,
          payer: '',
          reason: '',
          cargoDescription: '',
          cargoAdditionalInfo: ''
        },
        cargos: []
      },
      isUpdate: false,
      isEditable: true,
      fetchedOrder: null,
      pageIsLoading: false,
      isTest: false
    }
  },
  computed: {
    ...mapState(['route', 'cognito', 'locations', 'orders', 'signedInCompany']),
    ...mapGetters([
      'getLoggedInUserOrganizationID'
    ]),
    breadcrumbs () {
      return [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.tc('transport_request.transport_request', 2), disabled: false, href: '#/transport-request' },
        { text: this.breadcrumbField, disabled: true }
      ]
    },
    breadcrumbField () {
      if (!this.isUpdate) {
        return this.$i18n.t('buttons.create')
      } else {
        return `${this.order.objectID}: ${this.$i18n.t('detail')}`
      }
    },
    itemsCount () {
      return this.order.cargos.length
    },
    notValidCompanies () {
      // Check if one of buyer/seller is signed in company
      if (this.signedInCompany.name === undefined) {
        return false
      } else {
        return ((this.order.originAddress.company !== '' && this.order.originAddress.company !== this.signedInCompany.name) && (this.order.destinationAddress.company !== '' && this.order.destinationAddress.company !== this.signedInCompany.name))
      }
    },
    orderStatuses () {
      return [
        { value: 'requested', text: this.$i18n.t('transport_request.requested') },
        { value: 'accepted', text: this.$i18n.t('transport_request.accepted') },
        { value: 'booked', text: this.$i18n.t('transport_request.booked') },
        { value: 'cancelled', text: this.$i18n.t('transport_request.cancelled') },
        { value: 'rejected', text: this.$i18n.t('transport_request.rejected') },
        { value: 'missing_data', text: this.$i18n.t('transport_request.missing_data') }
      ]
    },
    userMail () {
      if (!!this.cognito && !!this.cognito.user && !!this.cognito.user.attributes && !!this.cognito.user.attributes.email && this.cognito.user.attributes.email !== '') {
        return this.cognito.user.attributes.email
      } else {
        console.error('email not found in Transport Request')
        return ''
      }
    }
  },
  methods: {
    ...mapActions({
      createOrder: 'createOrder',
      updateOrder: 'updateOrder',
      fetchLocationByID: 'fetchLocationByID',
      showSnackbar: 'showSnackbar',
      fetchLocations: 'fetchLocations',
      createTransport: 'createTransport'
    }),
    goBack () {
      router.push({ name: 'TransportRequest' })
    },
    checkAllValidation () {
      this.$refs['orderForm'].validate()
      this.valid = true
    },
    mapCargoTypeToUnitType (type) {
      // const availableTypes = ['box', 'pallet', 'bale', 'barrel', 'carton', 'crate', 'roll', 'package', 'bag', 'drum', 'bundle']
      switch (type) {
        case 'pallet':
          return 'CustomPallet'
        default:
          return 'CustomBox'
      }
    },
    mapTimeToAWSDateTime (date, time, flagFromTo = 'from') {
      let datetime = ''
      if (time != null) {
        datetime = `${date}:${time}`
      } else if (flagFromTo === 'to') {
        datetime = `${date}:${'23:00'}`
      } else {
        datetime = `${date}:${'00:00'}`
      }
      return moment(datetime, 'YYYY-MM-DD:HH:mm').format('YYYY-MM-DDThh:mm:ss.SSSZ')
    },
    async callUpdateOrder () {
      // this.order.isTest = true
      let validFormField = this.$refs['orderForm'].validate()
      this.checkAllValidation()
      if (validFormField && this.order.cargos.length > 0) {
        this.transformOrder()
        let snackMsg = ''
        let snackColor = ''
        console.log(this.order)
        const mappedCargo = [...this.order.cargos]
        const newTransport = {
          ref: null,
          origin: this.order.originAddress.locationID,
          destination: this.order.destinationAddress.locationID,
          pickup: {
            from: this.mapTimeToAWSDateTime(this.order.originAddress.dates_from, this.order.originAddress.open_from),
            to: this.mapTimeToAWSDateTime(this.order.originAddress.dates_to, this.order.originAddress.open_to, 'to')
          },
          delivery: {
            from: this.mapTimeToAWSDateTime(this.order.destinationAddress.dates_from, this.order.destinationAddress.open_from),
            to: this.mapTimeToAWSDateTime(this.order.destinationAddress.dates_to, this.order.destinationAddress.open_to, 'to')
          },
          units: mappedCargo.map((cargo) => {
            return {
              ref: null,
              type: this.mapCargoTypeToUnitType(cargo.type),
              weight: 0,
              dimensions: {
                length: parseInt(cargo.length),
                width: parseInt(cargo.width),
                height: parseInt(cargo.height)
              },
              items: [
                {
                  ref: null,
                  category: null,
                  name: null,
                  weight: (cargo.weight * 1000)
                }
              ]
            }
          }),
          order: null
        }
        // this.createTransport(newTransport)
        if (this.route.params.transportRequestID === undefined) {
          const resp = await transportRequestService.create(this.order)
          if (resp.error !== null) {
            console.error(resp.error)
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'error'
          } else {
            snackMsg = this.$i18n.t('snackbars.order_created')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
          setTimeout(this.goBack(), 1000)
        } else {
          const resp = await transportRequestService.create(this.order)
          if (resp.error !== null) {
            console.error(resp.error)
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'error'
          } else {
            snackMsg = this.$i18n.t('snackbars.order_updated')
            snackColor = 'success'
          }
          this.isEditable = false
          this.showSnackbar({ message: snackMsg, color: snackColor })
        }
      }
    },
    transformOrder () {
      this.order.originAddress.companyID = (this.order.originAddress.company.value ? this.order.originAddress.company.value : '')
      this.order.destinationAddress.companyID = (this.order.destinationAddress.company.value ? this.order.destinationAddress.company.value : '')
      this.order.originAddress.company = (this.order.originAddress.company.text ? this.order.originAddress.company.text : this.order.originAddress.company)
      this.order.destinationAddress.company = (this.order.destinationAddress.company.text ? this.order.destinationAddress.company.text : this.order.destinationAddress.company)
      this.order.originAddress.locationID = (this.order.originAddress.location.value ? this.order.originAddress.location.value.id : '')
      this.order.destinationAddress.locationID = (this.order.destinationAddress.location.value ? this.order.destinationAddress.location.value.id : '')
      this.order.originAddress.locShort = this.getShortLoaction(this.order.originAddress.location)
      this.order.destinationAddress.locShort = this.getShortLoaction(this.order.destinationAddress.location)
      this.order.originAddress.location = (this.order.originAddress.location.text ? this.order.originAddress.location.text : this.order.originAddress.location)
      this.order.destinationAddress.location = (this.order.destinationAddress.location.text ? this.order.destinationAddress.location.text : this.order.destinationAddress.location)

      this.order.originAddress.dates_fromTS = this.transformDate(this.order.originAddress.dates_from)
      this.order.originAddress.dates_toTS = this.transformDate(this.order.originAddress.dates_to)
      this.order.destinationAddress.dates_fromTS = this.transformDate(this.order.destinationAddress.dates_from)
      this.order.destinationAddress.dates_toTS = this.transformDate(this.order.destinationAddress.dates_to)
      this.order.userEmail = this.userMail

      if (this.order.originAddress.open_to === '00:00') {
        this.order.originAddress.open_to = '23:59'
      }
      if (this.order.destinationAddress.open_to === '00:00') {
        this.order.destinationAddress.open_to = '23:59'
      }
    },
    transformDate (input) {
      return new Date(input).getTime()
    },
    getShortLoaction (loc) {
      if (loc.value !== undefined && loc.value !== null && loc.value !== {}) {
        return loc.value.address.city + ', ' + loc.value.address.countryCode
      } else {
        return loc
      }
    },
    async fetchData () {
      this.pageIsLoading = true
      let transportRequestID = this.route.params.transportRequestID

      if (transportRequestID) {
        let tr = await transportRequestService.getTransportRequest(transportRequestID)
        this.order = tr.data

        this.isUpdate = true
        this.isEditable = false
      }
      this.pageIsLoading = false
    }
    // switchSites () {
    //   const pickup = {
    //     company: this.order.originAddress.company,
    //     location: this.order.originAddress.location,
    //     reference_number: this.order.originAddress.reference_number
    //   }
    //   this.$set(this.order.originAddress, 'company', this.order.destinationAddress.company)
    //   this.$set(this.order.originAddress, 'location', this.order.destinationAddress.location)
    //   this.$set(this.order.originAddress, 'reference_number', this.order.destinationAddress.reference_number)
    //   this.$set(this.order.destinationAddress, 'company', pickup.company)
    //   this.$set(this.order.destinationAddress, 'location', pickup.location)
    //   this.$set(this.order.destinationAddress, 'reference_number', pickup.reference_number)
    // },
    // printPdf () {
    //   window.html2canvas(this.showCapture())
    //     .then(function (canvas) {
    //       let img = canvas.toDataURL('image/png')
    //       let doc = new jsPDF('p', 'mm', 'a4')
    //       let width = doc.internal.pageSize.getWidth()
    //       let height = doc.internal.pageSize.getHeight()
    //       doc.addImage(img, 'PNG', 0, 0, width, height)
    //       doc.save('test.pdf')
    //     })
    // },
    // showCapture () {
    //   console.log(this.$refs.orderForm.$el)
    //   return this.$refs.orderForm.$el
    // }
  },
  async created () {
    // if (this.getLoggedInUserOrganizationID !== 'ea22334c-25eb-4eb7-bc70-1f30a04d7544') { // Page is only for CLIMAX
    //   this.$router.push({ name: 'OrdersOverview' })
    // }
    await this.fetchData()

  },
  mounted() {
    if (this.getLoggedInUserOrganizationID !== 'ea22334c-25eb-4eb7-bc70-1f30a04d7544' && this.getLoggedInUserOrganizationID != null) {
      // Page is only for CLIMAX
      this.$router.push({ name: 'OrdersOverview' })
    }
  },
  watch: {
    getLoggedInUserOrganizationID: {
      deep: true,
      handler (val, oldVal) {
        if (val !== 'ea22334c-25eb-4eb7-bc70-1f30a04d7544' && val != null) {
          this.$router.push({ name: 'OrdersOverview' })
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">
.transport-request-form-header {
  padding: 8px;
  background-color: #fff;
  border: 1px solid lightgray;
  border-bottom: none;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  margin-bottom: -2px;

  .activity-label {
    float: left;
    min-width: 95px;
  }
}
.address-origin {
  border-right: 1px solid #e2e2e2;
  border-top: 1px solid #e2e2e2;
}
.address-destination {
  border-top: 1px solid #e2e2e2;
}

.tr-priority {
  &.disabled {
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
      background-color: #ededed;

      .v-input__append-inner {
        display: none;
      }
    }
    ::v-deep .theme--light.v-input--is-disabled .v-label, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
      color: rgba(0, 0, 0, 0.87);
    }
    ::v-deep input {
      color: rgba(0, 0, 0, 0.87);
    }
    ::v-deep .v-select__selection {
      color: rgba(0, 0, 0, 0.87);
    }
  }
}

</style>
